"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualProductPaymentChoiceWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
require("react-datepicker/src/stylesheets/datepicker.scss");
var journey_model_1 = require("@athena-portal/journey-model");
var services_1 = require("@falcon/services");
var AnnualMotorMtaPremiumWordingGenerator_1 = require("../../../helpers/annual/motor/AnnualMotorMtaPremiumWordingGenerator");
var core_1 = require("@athena-portal/core");
var moment = require("moment/moment");
var components_1 = require("@athena-portal/components");
var commonFunctions_1 = require("../../../commonFunctions");
var AnnualProductPaymentChoiceWidget = exports.AnnualProductPaymentChoiceWidget = /** @class */ (function (_super) {
    __extends(AnnualProductPaymentChoiceWidget, _super);
    function AnnualProductPaymentChoiceWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnChangeEvent = function (event) {
            if (event.target.value === "fullPrice") {
                _this.props.onStateChange("uistate.payFullPrice", true);
                _this.setState({ payFullPrice: true, selected: true });
            }
            else if (event.target.value === "partOfPrice") {
                _this.props.onStateChange("uistate.payFullPrice", false);
                _this.setState({ payFullPrice: false, selected: true });
            }
            // Re-generate MTA success modal body wording
            // due to choice between immediate payment and spreading additional premium across existing monthly payments
            if (_this.props.interaction.product !== services_1.ProductsEnum.HOME) {
                var mtaPremiumWording = AnnualMotorMtaPremiumWordingGenerator_1.AnnualMotorMtaPremiumWordingGenerator.generateMtaPremiumWording(_this.props.interaction, _this.state.policies);
                if (mtaPremiumWording.isGenericModalBodyWording) {
                    window.sessionStorage.setItem("mtaHeadsUpMessageText", mtaPremiumWording.successModalBodyWording);
                }
                else {
                    window.sessionStorage.setItem("mtaSuccessMessageText", mtaPremiumWording.successModalBodyWording);
                }
            }
        };
        _this.navigateNext = function () {
            _this.props.engine.navigate(_this.getSetting("paymentPageId"));
        };
        _this.navigateBack = function () {
            if (_this.getSetting("previousPageId")) {
                _this.props.engine.navigate(_this.getSetting("previousPageId"));
            }
        };
        _this.state = {
            payFullPrice: false,
            isVulnerableCustomer: false,
            isMTC: false,
            selected: false,
            remainingAmountPresent: true,
            dataLoaded: false,
            policies: [],
        };
        return _this;
    }
    AnnualProductPaymentChoiceWidget_1 = AnnualProductPaymentChoiceWidget;
    AnnualProductPaymentChoiceWidget.prototype.componentDidMount = function () {
        var _this = this;
        var interaction = this.props.engine.getInteraction();
        var isVulnerableCustomer = interaction.uistate.vulnerableCustomer;
        var isMTC = interaction.process === "MTC";
        var product = services_1.productHelper.isHome(interaction) ? services_1.ProductsEnum.HOME : services_1.ProductsEnum.WOLF_MOTOR;
        this.customerPortalService.getPolicies(product).subscribe(function (policies) {
            _this.setState({
                policies: policies
            });
            var policiesByProduct = policies.filter(function (policy) { return policy.products.includes(product); })
                .sort(function (a, b) { return moment(b.endDate).diff(a.endDate); });
            if (policiesByProduct && policiesByProduct.length > 0) {
                var policy = policiesByProduct[0];
                var hasRenewal = policy.policyHistoryList.some(function (ph) { return ph.status === "RENEWAL"; });
                if (hasRenewal) {
                    policy.policyHistoryList = policy.policyHistoryList.filter(function (ph) { return ph.status !== "NEW"; });
                }
                var agreementVersionIds = policy.policyHistoryList.map(function (ph) { return ph.id; });
                _this.customerPortalService.getCombinedInstalmentsInfo(agreementVersionIds)
                    .subscribe(function (instalmentsInfo) {
                    var remainingAmountPresent = Math.abs(instalmentsInfo === null || instalmentsInfo === void 0 ? void 0 : instalmentsInfo.remainingAmount) !== 0;
                    _this.setState({
                        remainingAmountPresent: remainingAmountPresent,
                        dataLoaded: true
                    });
                });
            }
        });
        this.setState({
            isVulnerableCustomer: isVulnerableCustomer,
            isMTC: isMTC,
        });
    };
    AnnualProductPaymentChoiceWidget.prototype.render = function () {
        var uiStatePayFullPrice = this.props.interaction.uistate.payFullPrice;
        var disabledClass = uiStatePayFullPrice !== undefined ? "" : "btn-disabled";
        var additionalPremium = this.props.interaction.factors.additionalPremium;
        var upfrontPaymentAmount = this.props.interaction.factors.upfrontPaymentAmount;
        var spreadIncludesInterest = !!this.props.interaction.factors.monthlyPaymentSpreadWithInterestAmount;
        var monthlyPaymentsSpread = this.getMonthlyPaymentsSpread(spreadIncludesInterest);
        var isDirectDebit = services_1.productHelper.isDirectDebit(this.props.interaction);
        var disableUpfrontPayment = AnnualProductPaymentChoiceWidget_1.getDisableUpfrontPayment(isDirectDebit, upfrontPaymentAmount, additionalPremium);
        var manyPaymentChoice = this.state.remainingAmountPresent ? "d-flex" : "text-center";
        if (this.state.dataLoaded) {
            return (React.createElement("div", { className: "w-100" },
                React.createElement("div", { className: "payment-choice ".concat(manyPaymentChoice) },
                    React.createElement("div", { className: "custom-control custom-radio w-50 mx-0 pr-2" },
                        React.createElement("input", { id: "yearly", className: "custom-control-input", type: "radio", name: "payment", value: "fullPrice", onChange: this.handleOnChangeEvent }),
                        React.createElement("label", { className: "custom-control-label h-100 p-2", htmlFor: "yearly" },
                            this.state.selected && this.state.payFullPrice
                                ? React.createElement("img", { className: "radio-circle", alt: "full selected", src: "/img/radio-circle-selected.svg" })
                                : React.createElement("img", { className: "radio-circle", alt: "full", src: "/img/radio-circle.svg" }),
                            React.createElement("p", { className: "font-weight-semi-bold pt-3" },
                                "Pay ",
                                (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.factors.additionalPremium),
                                " now by card"),
                            React.createElement("div", null,
                                React.createElement("img", { className: "visa-icon-small", alt: "visa-icon", src: "/img/visa-icon.svg" }),
                                React.createElement("img", { className: "mastercard-icon-small", alt: "mastercard-icon", src: "/img/mastercard-icon.svg" })))),
                    this.state.remainingAmountPresent &&
                        React.createElement("div", { className: "custom-control custom-radio w-50 mx-0 pl-2" },
                            React.createElement("input", { id: "monthly", className: "custom-control-input", type: "radio", name: "payment", value: "partOfPrice", onChange: this.handleOnChangeEvent }),
                            React.createElement("label", { className: "custom-control-label h-100 p-2", htmlFor: "monthly" },
                                this.state.selected && !this.state.payFullPrice
                                    ? React.createElement("img", { className: "radio-circle", alt: "monthly selected", src: "/img/radio-circle-selected.svg" })
                                    : React.createElement("img", { className: "radio-circle", alt: "monthly", src: "/img/radio-circle.svg" }),
                                !this.state.isVulnerableCustomer && disableUpfrontPayment ?
                                    React.createElement(React.Fragment, null,
                                        React.createElement("p", { className: "font-weight-semi-bold pt-3" }, "Monthly payments"),
                                        React.createElement("p", { className: "pt-3" }, "Continue with your monthly payment plan")) :
                                    React.createElement("p", { className: "font-weight-semi-bold pt-3" },
                                        "Pay ",
                                        (0, commonFunctions_1.getAmountToDisplay)(upfrontPaymentAmount),
                                        " now and continue to pay\u00A0",
                                        (0, commonFunctions_1.getAmountToDisplay)(monthlyPaymentsSpread),
                                        " ",
                                        spreadIncludesInterest && "(incl. interest)",
                                        " with your monthly payments"),
                                this.state.isVulnerableCustomer && this.state.isMTC &&
                                    React.createElement(React.Fragment, null,
                                        React.createElement("p", { className: "font-weight-semi-bold pt-3" }, "Monthly payments"),
                                        React.createElement("p", { className: "pt-3" }, "Continue with your monthly payment plan"))))),
                this.getSetting("paymentPageId") &&
                    React.createElement("button", { className: "mb-0 btn btn-primary btn-next ".concat(disabledClass), id: "".concat(this.props.question.name), onClick: this.navigateNext }, "Next"),
                this.getSetting("previousPageId") && React.createElement("button", { className: "btn btn-back", onClick: this.navigateBack }, "Back")));
        }
        else {
            return React.createElement(components_1.Overlay, { show: true });
        }
    };
    AnnualProductPaymentChoiceWidget.getDisableUpfrontPayment = function (isDirectDebit, upfrontPaymentAmount, additionalPremium) {
        return isDirectDebit ? upfrontPaymentAmount <= 0 : (upfrontPaymentAmount < services_1.UPFRONT_PAYMENT_THRESHOLD || additionalPremium < services_1.UPFRONT_PAYMENT_THRESHOLD);
    };
    AnnualProductPaymentChoiceWidget.prototype.getMonthlyPaymentsSpread = function (spreadIncludesInterest) {
        return spreadIncludesInterest
            ? this.props.interaction.factors.monthlyPaymentSpreadWithInterestAmount
            : this.props.interaction.factors.monthlyPaymentSpreadAmount;
    };
    var AnnualProductPaymentChoiceWidget_1;
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], AnnualProductPaymentChoiceWidget.prototype, "customerPortalService", void 0);
    AnnualProductPaymentChoiceWidget = AnnualProductPaymentChoiceWidget_1 = __decorate([
        (0, journey_model_1.settings)([
            { name: "previousPageId", type: journey_model_1.TypeDescriptions.String },
            { name: "paymentPageId", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], AnnualProductPaymentChoiceWidget);
    return AnnualProductPaymentChoiceWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=AnnualProductPaymentChoiceWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/common/AnnualProductPaymentChoiceWidget.js
// module id = 1249
// module chunks = 0